import { render } from "./battlePanel.vue?vue&type=template&id=977dcd86&scoped=true"
import script from "./battlePanel.vue?vue&type=script&lang=ts"
export * from "./battlePanel.vue?vue&type=script&lang=ts"

import "./battlePanel.vue?vue&type=style&index=0&id=977dcd86&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-977dcd86"

export default script